
module.config(function($stateProvider) {

    $stateProvider.state('student.activities', {
        url: '/activities',
        templateUrl: 'students/activities/page',
        permission: 'viewParticipantActivities',
        resolve: {
            auth: function($checkPermissions, student, permissions) {
                if (student.has_enrollment || student.activities > 0) {
                    return true;
                }
                return $checkPermissions('administerStudents', permissions);
            },
            activityTypes: function(ModelConfig) {
                return ModelConfig.getOptions('activity_type');
            },
            activities: function(ModelService, student) {
                return ModelService.getRelation('participant', student.id, 'activities')
            }
        },
        controller: module.cC({
            inject: ['$scope', 'activities', 'activityTypes', 'ModelService'],
            data: {'activities': 'activities'},
            init: function() {
                this.$.sortOrder = [this.sortType, '-activity_date'];
            },
            listen: {
                participant_activity: {
                    create: '_appendActivity',
                    delete: '_removeActivity',
                },
            },
            methods: {
                sortType: function(item) {
                    return this.activityTypes.index[item.activity_type];
                },

                _appendActivity: function(id, owner) {
                    if (owner === this.$.student.id) {
                        this.ModelService.debouncedGet('participant_activity', id)
                            .then(this.ModelService.appendToArray(this.activities));
                    }
                },

                _removeActivity: function(id, owner) {
                    if (owner === this.$.student.id) {
                        this.ModelService.removeById('participant_activity', id,
                                                     this.activities);
                    }
                },
            },
        }),
    });

});

